import React, { useState, useRef } from "react";
import { Avatar, Menu, MenuItem, IconButton, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import firebase from "firebase/app";

export default function UserMenu({ userName, userImageUrl }: { userName?: string; userImageUrl?: string }) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleLogout = () => {
    firebase.auth().signOut().catch(console.error);
    handleClose();
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
      <Typography variant="body1" sx={{ whiteSpace: "nowrap", fontWeight: 500 }}>
        {userName || ""}
      </Typography>
      <IconButton onClick={handleClick} sx={{ p: 0 }}>
        <Avatar alt="Avatar" src={userImageUrl} sx={{ width: 36, height: 36 }} />
        <KeyboardArrowDownIcon sx={{ ml: 0.5 }} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{ elevation: 3, sx: { mt: 1.2, borderRadius: "8px" } }}
      >
        <MenuItem onClick={handleLogout}>Cerrar sesión</MenuItem>
      </Menu>
    </div>
  );
}
